const PAUSE_HISTORY_TYPES = {
  PAUSE_HISTORY: 'pause-history',
  MAKEUP_CLASSES: 'makeup-classes',
};

const PAUSE_FILTER_OPTIONS = [
  {
    value: PAUSE_HISTORY_TYPES.PAUSE_HISTORY,
    label: 'Pause history',
  },
  {
    value: PAUSE_HISTORY_TYPES.MAKEUP_CLASSES,
    label: 'Makeup classes',
  },
];

const PAUSE_HISTORY_INFO_DRAWER = 'pause-info-drawer';
const MAKE_UP_CLASSES_INFO_DRAWER = 'make-up-classes-info-drawer';

const MAKE_UP_CLASSES_FILTERS = [
  {
    key: 'student_course_ids',
    label: 'Student course Id',
    type: 'text',
  },
  {
    key: 'student_leave_usage_ids',
    label: 'Student leave usage Id',
    type: 'text',
  },
  {
    key: 'teacher_leave_usage_ids',
    label: 'Teacher leave usage Id',
    type: 'text',
  },
  {
    key: 'lapse_date',
    label: 'Lapse date',
    type: 'date',
  },
];

export const MAKE_UP_CLASSES_STATES_OPTIONS = [
  { key: 'CREATED', value: 'CREATED', text: 'CREATED' },
  { key: 'LAPSED', value: 'LAPSED', text: 'LAPSED' },
  { key: 'RESCHEDULE_DONE', value: 'RESCHEDULE_DONE', text: 'RESCHEDULE_DONE' },
  { key: 'RESCHEDULE_CREATED', value: 'RESCHEDULE_CREATED', text: 'RESCHEDULE_CREATED' },
  {
    key: 'RESCHEDULE_T_NO_SHOW',
    value: 'RESCHEDULE_T_NO_SHOW',
    text: 'RESCHEDULE_T_NO_SHOW',
  },
  {
    key: 'RESCHEDULE_S_NO_SHOW',
    value: 'RESCHEDULE_S_NO_SHOW',
    text: 'RESCHEDULE_S_NO_SHOW',
  },
  {
    key: 'RESCHEDULE_NOT_DONE',
    value: 'RESCHEDULE_NOT_DONE',
    text: 'RESCHEDULE_NOT_DONE',
  },
  { key: 'RESCHEDULE_EXPIRED', value: 'RESCHEDULE_EXPIRED', text: 'RESCHEDULE_EXPIRED' },
];

export {
  MAKE_UP_CLASSES_FILTERS,
  PAUSE_HISTORY_TYPES,
  PAUSE_FILTER_OPTIONS,
  PAUSE_HISTORY_INFO_DRAWER,
  MAKE_UP_CLASSES_INFO_DRAWER,
};
